import { BookingInvoice } from "../../../models/booking/BookingInvoice";
import { AvailableServiceTimeSlots } from "../../entities/booking/AvailableServiceTimeSlots";
import { BookingModel } from "../../entities/booking/BookingModel";
import { BaseDataRepository } from "../BaseDataRepository";
export class BookingRepo extends BaseDataRepository<BookingModel> {
  protected baseUrl = 'booking';


  async getAvailableServiceTimeSlots(locationId: number, providerId: number | null, serviceId: number, startDate: Date, endDate: Date): Promise<AvailableServiceTimeSlots[] | null> {
    const response = await this.client.get(`${this.baseUrl}/availableservicetimeslots/location/${locationId}/service/${serviceId}`, {
      params: {
        providerId: providerId,
        startDate: startDate.toDateString(),
        endDate: endDate.toDateString()
      },
    });
    return this.handleResponse<Promise<AvailableServiceTimeSlots[]>>(response);
  }

  async getAvailableServiceDays(locationId: number, startDate: Date, endDate: Date, serviceProviderPairs: Record<number, number | null>): Promise<Date[] | null> {
    const params = {
      startDate: startDate.toDateString(),
      endDate: endDate.toDateString(),
      ...Object.fromEntries(Object.entries(serviceProviderPairs).map(([key, value]) => [`serviceProviderPairs[${key}]`, value]))
    };

    const response = await this.client.get(`${this.baseUrl}/availableservicedays/location/${locationId}`, { params });
    return this.handleResponse<Promise<Date[]>>(response);
  }

  async initiateBooking(booking: BookingModel): Promise<BookingInvoice | null> {
    const response = await this.client.post(`${this.baseUrl}/initiate`, booking);
    return this.handleResponse<Promise<BookingInvoice>>(response);
  }

  async markBookingAsCompletedAsync(bookingId: number): Promise<void | null> {
    const response = await this.client.patch(`${this.baseUrl}/complete/${bookingId}`);
    return this.handleResponse<Promise<void>>(response);
  }

  async getBookingWithInvoiceAsync(bookingId: number): Promise<BookingInvoice | null>{
    const response = await this.client.get(`${this.baseUrl}/GetBookingWithInvoice/${bookingId}`);
    return this.handleResponse<Promise<BookingInvoice | null>>(response);
  }

  async discardDraftBookingAsync(bookingId: number, invoiceId: number): Promise<void | null>{
    const response = await this.client.delete(`${this.baseUrl}/discardDraftBooking/booking/${bookingId}/invoice/${invoiceId}`);
    return this.handleResponse<Promise<void | null>>(response);
  }

  async getDraftStatus(bookingId: number): Promise<{ bookingId: number; status: string; invoiceId?: number; expiresAtUtc?: string } | null> {
    const response = await this.client.get(`${this.baseUrl}/draft/${bookingId}/status`);
    return this.handleResponse<Promise<{ bookingId: number; status: string; invoiceId?: number; expiresAtUtc?: string }>>(response);
  }

  async getCancelPreviewAsync(token: string): Promise<any> {
    const response = await this.client.get(`${this.baseUrl}/cancel/preview`, { params: { token } });
    return this.handleResponse<any>(response, false);
  }

  async cancelByTokenAsync(token: string): Promise<void | null> {
    const response = await this.client.post(`${this.baseUrl}/cancel`, null, { params: { token } });
    return this.handleResponse<Promise<void | null>>(response, false);
  }

}

export default BookingRepo;
